var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 37.3884V3.75C1.5 2.50733 2.50733 1.5 3.75 1.5H26.25C27.4927 1.5 28.5 2.50733 28.5 3.75V37.3884L15.7558 29.9543L15 29.5134L14.2442 29.9543L1.5 37.3884Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackBookmark);
export default __webpack_public_path__ + "static/media/black-bookmark.cc8bbe84327caba64501d7592a0c3cff.svg";
export { ForwardRef as ReactComponent };